import { TranslationKey, useTranslation } from 'module/hooks/use-translation';
import {
  TextFieldFilter,
  TextFieldFilterOperationType,
} from 'module/types/filter-field/filter/text';
import { snakeCase, startCase } from 'lodash';
import { FC } from 'react';
import { removeTrailingDots } from './utils';

export const TextFilterToText: FC<
  React.PropsWithChildren<{ filter: TextFieldFilter }>
> = ({ filter }) => {
  const {
    field: { fieldLabel },
    type,
  } = filter;

  return (
    <span>
      {startCase(fieldLabel)}{' '}
      {removeTrailingDots(
        useTranslation(
          `task_list.filters.${snakeCase(type)}` as TranslationKey,
        ),
      )}{' '}
      {filter.type === TextFieldFilterOperationType.Contains ||
      filter.type === TextFieldFilterOperationType.DoesNotContain
        ? filter.value
        : null}
    </span>
  );
};
